import { LoadingEvent } from "@iventis/types/loading.types";
import { useSelector } from "react-redux";
import { RootState } from "../state/root.store";

export const useMapLoading = (): boolean => {
    const waitingFor = useSelector((s: RootState) => s.mapReducer.waitingFor);
    return waitingFor?.some((e) => e.eventName === LoadingEvent.GET_MAP || e.eventName === LoadingEvent.GET_PROJECT_DATAFIELDS || e.eventName === LoadingEvent.GET_SITEMAPS);
};
